import { useState, useEffect } from 'react';
import { Medal, CheckCircle } from 'lucide-react';
import { getAllAchievements, getMyAchievements } from '../../services/achievements';

export default function Achievements() {
  const [all, setAll] = useState([]);
  const [mine, setMine] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([getAllAchievements(), getMyAchievements()])
      .then(([a, m]) => { setAll(a.data); setMine(m.data); })
      .catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-64"><div className="animate-spin rounded-full h-8 w-8 border-2 border-blue-500 border-t-transparent"></div></div>;

  const earnedIds = new Set(mine.map(a => a.id));

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-2xl p-8 text-white text-center">
        <h1 className="text-3xl font-bold mb-2 flex items-center justify-center gap-2"><Medal className="w-8 h-8" /> Yutuqlar</h1>
        <p className="text-purple-100">{mine.length} / {all.length} yutuq qo'lga kiritilgan</p>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {all.map(a => {
          const earned = earnedIds.has(a.id);
          return (
            <div key={a.id} className={`bg-white rounded-2xl p-5 border transition ${earned ? 'border-yellow-300 shadow-md' : 'border-gray-100 opacity-60'}`}>
              <div className="flex items-center gap-4">
                <div className={`text-4xl ${earned ? '' : 'grayscale'}`}>{a.icon}</div>
                <div className="flex-1">
                  <h3 className="font-bold text-gray-900">{a.name}</h3>
                  <p className="text-sm text-gray-500">{a.description}</p>
                  <div className="flex items-center gap-3 mt-2">
                    <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded-full">+{a.xp_reward} XP</span>
                    {earned && <span className="text-xs text-green-600 font-medium flex items-center gap-1"><CheckCircle className="w-3 h-3" /> Qo'lga kiritilgan</span>}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}